import { createContext, useContext } from 'react';
import type { Me } from '../types';

export interface KanzleiValue {
  me: Me;
}

export const KanzleiContext = createContext<KanzleiValue | null>(null);

export function useKanzlei(): KanzleiValue {
  const v = useContext(KanzleiContext);
  if (!v) throw new Error('useKanzlei außerhalb des Kanzlei-Dashboards');
  return v;
}
